import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
} from "react";
import V2Context, { V2ContextValue } from "contexts/V2Context";
import useFetchV2Metadata from "hooks/useFetchV2Metadata";
import V2Redirect from "guards/V2Redirect";
import useTokenIdParam from "hooks/useTokenIdParam";
import { usePrevious } from "@chakra-ui/react";

type V2ProviderProps = {};

const V2Provider: FunctionComponent<V2ProviderProps> = ({ children }) => {
  const tokenId = useTokenIdParam();
  const lastTokenId = usePrevious(tokenId);

  const [metadata, fetchMeta, isLoading] = useFetchV2Metadata(tokenId);

  const fetchMetadata = useCallback(() => {
    if (tokenId) {
      fetchMeta(tokenId);
    }
  }, [tokenId, fetchMeta]);

  useEffect(() => {
    V2Redirect.storeLastTokenId(tokenId);

    if (lastTokenId === undefined) {
      return;
    }

    if (tokenId !== lastTokenId) {
      fetchMetadata();
    }
  }, [tokenId, lastTokenId, fetchMetadata]);

  const contextValue = useMemo<V2ContextValue>(
    () => ({
      tokenId,
      metadata,
      isLoading,
      fetchMetadata,
    }),
    [tokenId, metadata, isLoading, fetchMetadata]
  );

  return (
    <V2Context.Provider value={contextValue}>{children}</V2Context.Provider>
  );
};

export default V2Provider;
